import React from 'react';
import Box from "@amzn/meridian/box";
import TopMetricsRow from '../../TopMetricsRow/v2/TopMetricsRowContainer';

/**
 * Refactored (V2) metrics section — UTR-REFLEX-1163. Renders the V2 three-card
 * top metrics row from the currently-selected plan's output. Sibling of
 * MetricsSection so V1 is untouched. Layout comes from Meridian (Box), so no
 * custom CSS.
 */
const MetricsSection: React.FC = () => {
  return (
    <Box>
      <TopMetricsRow />
    </Box>
  );
};

export default MetricsSection;
